import { Component, OnInit, ViewChild } from '@angular/core';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { Endpoints } from '@huge-monorepo/portal/config';
import { ScreenSize } from 'libs/portal/src/layout/layout.service';
import { CardTableOptions } from 'libs/portal/src/modules/tools/card-table/models';
import { CardTableHeader } from 'libs/portal/src/modules/tools/card-table/models/card-table-header.model';
import { DateTimeComponent } from 'libs/portal/src/modules/tools/date-time/date-time.component';
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';
import { PaginationService } from 'libs/portal/src/services/pagination/pagination.service';
import { GenericTableHeaderOptions } from 'libs/portal/src/modules/tools/card-table/models/generic-table-header-options.model';
import { UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { Subscription } from 'rxjs';
import { ServerGroups } from '../../relay/interfaces/DashboardServer.interface';

@Component({
  selector: 'app-relay-ip-report',
  templateUrl: './relay-ip-report.component.html',
  styleUrls: ['./relay-ip-report.component.scss'],
})
export class RelayIpReportComponent implements OnInit {
  @ViewChild('date', { static: false }) datesComponent: DateTimeComponent;
  @ViewChild('date2', { static: false }) datesComponent2: DateTimeComponent;
  httpObject = {};
  startDate: string;
  endDate: string;
  startDateTime: string;
  endDateTime: string;
  currentPage = 0;
  resetHeader = false;
  groups: any[] = [];
  group: string;

  loading = false;
  todayT = '';
  reportResults: [] = [];
  resetting = false;
  date = new Date();
  firstDay = this.getFirstDayOfMonth(this.date.getFullYear(), this.date.getMonth());
  displayResults = false;

  headerOptions: GenericTableHeaderOptions = {
    ShowSearch: false,
    DefaultDesc: true,
    DateItem: {
      Singular: false,
      Title: 'Select date range',
      StartDate: this.tools.StartOfMonth().toDateString(),
      EndDate: new Date().toDateString(),
    },
    DateRequired: true,
    EnableExport: false,
    EnableSelectAll: false,
    DropDownOptions: [],
  };

  options: CardTableOptions = {
    titleProperty: 'Name',
    rowId: 'ID',
    subTitleProperty: 'data',
    additionalProperty: 'status',
    indicatorColorProperty: 'color',
    selectedProperty: 'selected',
    isSelectable: false,
    flexCardLayout: false,
    propertyRowExclusions: ['ID', 'Description'],
    stylePropertyPrefix: 'alerts',
    clickableFlexCard: false,
    textSize: 'regular',
  };

  ScreenSize = ScreenSize;

  authSubscription: Subscription;
  obfuscateDetails = false;

  resultsHeaders: CardTableHeader[] = [
    {
      ID: 'SourceIP',
      Index: 0,
      Sort: 'SourceIP',
      Sortable: false,
      Text: 'Source IP',
      Width: 20,
    },
    {
      ID: 'Count',
      Index: 3,
      Sort: 'Count',
      Sortable: false,
      Text: 'Total',
      Width: 20,
      Wrapper: (obj, elem) => {
        if (elem != null) {
          return Math.round(elem);
        }
        return '-';
      },
    },
    {
      ID: 'Group',
      Index: 1,
      Sort: 'Group',
      Sortable: false,
      Text: 'Group Name',
      Width: 20,
    },
    {
      ID: 'APN',
      Index: 2,
      Sort: 'APN',
      Sortable: false,
      Text: 'APN Name',
      Width: 20,
    },
  ];

  constructor(
    private genericService: GenericService,
    private tools: ToolsService,
    private endpoints: Endpoints,
    private paginationService: PaginationService,
    private auth: UserRightsService,
  ) {}

  ngOnInit(): void {
    this.authSubscription = this.auth.GetUser().subscribe((user) => {
      const prev = this.obfuscateDetails;
      if (user.isObfuscated) {
        this.obfuscateDetails = true;
      } else {
        this.obfuscateDetails = false;
      }

      if (prev != this.obfuscateDetails) {
        this.groups = [];
        this.headerOptions.DropDownOptions = [];

        if (this.displayResults) {
          this.EnquireReportInfo();
        }
      }
      this.getGroups();
    });
  }

  getGroups() {
    this.startDate = this.tools.isoDateWithoutTimeZone(this.tools.GetStartOfMonth(new Date())).toISOString();
    this.endDate = this.tools.GetEndOfDay(this.tools.isoDateWithoutTimeZone(new Date())).toISOString();
    this.headerOptions.EnableClear = false;
    this.headerOptions.EnableView = false;
    this.headerOptions.EnableExport = false;
    this.headerOptions.DropDownOptions = [];
    this.groups = [];

    this.genericService.GET(this.endpoints.GET_RELAY_GROUPS).subscribe(
      (data: Object) => {
        let serverArray = data['body'];
        serverArray?.forEach((element: ServerGroups) => {
          if (element.GroupName == '') {
            element.GroupName = 'Unassigned';
          }
          element.OriginalName = element.GroupName;
          if (this.obfuscateDetails) {
            element.GroupName = this.tools.Obfuscate(element.GroupName, 'Group ', 4);
          }
          this.groups.push(element);
        });
        this.headerOptions.DropDownOptions.push({
          Label: 'Group',
          options: this.groups,
          attribute: 'GroupName',
        });
      },
      (error: any) => {
        console.log(error);
      },
    );
  }

  updateDate(newDate: string) {
    this.startDate = newDate;
  }

  updateEndDateTime(newDate: string) {
    this.endDateTime = newDate;
  }

  downloadReport() {
    this.loading = true;
    this.httpObject = {
      StartDate: this.startDate,
      EndDate: this.endDate,
      Group: this.group,
    };
    if (this.isValid()) {
      this.genericService.download(this.endpoints.GENERATE_RELAY_IP_REPORT(null, false), this.httpObject).subscribe((results) => {
        this.reportResults = results as [];
        this.loading = false;
        // this.genericService.createToast("Report Downloading", "Your report will start downloading momentarily");
        this.reset();
      });
    }
  }

  scheduleDownload() {
    this.httpObject = {
      StartDate: this.startDate,
      EndDate: this.endDate,
      Group: this.group,
    };
    if (this.isValid()) {
      this.loading = true;
      this.genericService.POST(this.endpoints.GENERATE_RELAY_IP_REPORT(true, true), this.httpObject).subscribe((results) => {
        this.loading = false;
        // this.snack.createReportQueuedSnack();
      });
    }
  }

  EnquireReportInfo() {
    this.reportResults = [];
    this.loading = true;
    this.httpObject = {
      StartDate: this.startDate,
      EndDate: this.endDate,
      Group: this.group,
    };
    this.genericService.POST(this.endpoints.GENERATE_RELAY_IP_REPORT(true, false), this.httpObject).subscribe((results) => {
      this.reportResults = results['body'] as [];
      if (this.reportResults) {
        this.reportResults.forEach((element: any) => {
          Object.keys(element).forEach(function (key) {
            if (element[key] === null) {
              element[key] = '-';
            }
          });
          if (this.obfuscateDetails) {
            element.Group = this.tools.Obfuscate(element.Group, 'Group ', 4);
            element.APN = this.tools.Obfuscate(element.APN, 'APN ', 4);
          }
        });
      }
      this.displayResults = true;
      this.loading = false;
    });
  }

  getFirstDayOfMonth(year, month) {
    const date = new Date(year, month, 1, 2, 0);
    return date.toISOString();
  }

  reset() {
    this.resetHeader = true;
    this.reportResults = [];
    this.startDate = this.tools.isoDateWithoutTimeZone(this.tools.GetStartOfMonth(new Date())).toISOString();
    this.endDate = this.tools.GetEndOfDay(this.tools.isoDateWithoutTimeZone(new Date())).toISOString();
    this.displayResults = false;
    this.headerOptions.EnableClear = false;
    this.ngOnInit();
    this.group = '';
    setTimeout(() => {
      this.resetHeader = false;
    });
  }

  isValid(): Boolean {
    return true;
  }

  groupSelect(event: any) {
    this.headerOptions.EnableView = true;
    this.headerOptions.EnableClear = true;
    this.headerOptions.EnableExport = true;

    this.group = event.Value.OriginalName;
  }

  onPageChange(event: any) {
    this.currentPage = event;
    const startIndex = (this.currentPage - 1) * 10;
    let endIndex = startIndex + 10;
    if (endIndex > this.reportResults.length) {
      endIndex = this.reportResults.length;
    }
    setTimeout(() => {
      this.paginationService.emit();
    });
  }

  setDate(event: any) {
    if (event.endDate != null) {
      this.startDate = this.tools.isoDateWithoutTimeZone(new Date(event.startDate)).toISOString();
      this.endDate = this.tools.GetEndOfDay(this.tools.isoDateWithoutTimeZone(new Date(event.endDate))).toISOString();
    }
  }
}
